<template>
  <div>
    <component :is="template"></component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { STORE_KEY } from "./_store/constants";
import store from "./_store";
import ViewListClass from "./_view/ViewListClass";
import ViewDetailSubject from "./_view/ViewDetailSubject";
import viewDetailDiscuss from "./_view/viewDetailDiscuss";
import ViewdetailCalendar from "./_view/ViewdetailCalendar"
import ViewDetailDoccument from "./_view/ViewDetailDoccument"
import ViewCodeClass from "./_components/ViewCodeClass"
import ViewDetailSubjectContent from "./_view/ViewDetailSubjectContent"
import test from "./_view/test"

export default {
  name: "ClassRoomModule",
  props: {
    template: String
  },
  components: {
    ViewListClass,
    viewDetailDiscuss,
    ViewDetailSubject,
    ViewdetailCalendar,
    ViewDetailDoccument,
    ViewCodeClass,
    ViewDetailSubjectContent,
    test
  },
  created() {
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
};
</script>